import React, { useEffect, useState } from "react";
import TextInput from "../sharedComponents/inputs/textInput";
import Lang from "../../userPreferences/staticWords";
import { getAllLinksAPI } from "../../API/store/actions/agendaAndLinks";
import { useDispatch, useSelector } from "react-redux";

const LinksList = () => {
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const userToken = useSelector((state) => state.login.userToken);

  useEffect(() => {
    const load = async () => {
      setLoading(true);

      try {
        const payload = {
          active: true,
        };

        const action = await getAllLinksAPI(payload, userToken);
        dispatch(action);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [userToken, dispatch]);

  const links = useSelector((state) => state.links.links);
  const filteredLinks = (links || []).filter((item) =>
    item.name?.toLowerCase().includes((searchValue || "").toLowerCase()),
  );
  return (
    <div
      className="d-flex flex-column col-xl-4 col-12 overflow-auto px-4 scrollHome fixedClassHome2"
      style={{
        backgroundColor: "#f2f2f2",
        height: "100%",
        paddingBottom: 100,
      }}
    >
      <div className="d-flex align-items-center">
        <img src="/assets/images/links.svg" width={25} height={25} alt="" />
        <p className="mt-3 px-2" style={{ fontSize: 25 }}>
          قائمة الروابط الهامة
        </p>
      </div>
      <input
        type="text"
        placeholder={Lang.search}
        className="form-control w-[90%]!important"
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
      />

      <div className="mt-3">
        {loading ? (
          <div className="d-flex justify-content-center align-items-center py-5">
            <div className="spinner-border text-success" role="status">
              <span className="visually-hidden">...جاري التحميل</span>
            </div>
          </div>
        ) : filteredLinks.length > 0 ? (
          filteredLinks.map((link, index) => (
            <div
              className="d-flex flex-column w-100 mb-3 p-3"
              style={{
                backgroundColor: "#fff",
                borderRadius: 10,
                boxShadow: "1px 1px 7px #ccc",
              }}
            >
              <div className="fw-bold fs-5">{link.name}</div>

              <div dir="ltr" className="w-100">
                <a
                  href={link.url}
                  target="_blank"
                  rel="noreferrer"
                  className="text-black fs-5 text-decoration-none d-block w-100"
                  style={{ textAlign: "left" }}
                >
                  {link.url}
                </a>
              </div>
            </div>
          ))
        ) : (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              minHeight: "200px",
              backgroundColor: "#fff",
              borderRadius: 10,
              boxShadow: "1px 1px 7px #ccc",
            }}
          >
            <p className="m-0 fs-5 text-muted">لا توجد روابط متاحة</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LinksList;
